import { SERVER } from "../environment.constants";

export class GeocodingUrl {
    public static geocoding: string = SERVER + "/geocoding";
}